/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantId = exports.Operator = exports.OfflineChannelId = exports.MessageChannelId = exports.DeliveryMethodId = exports.ChatroomKey = void 0;
var ChatroomKey;
(function (ChatroomKey) {
    ChatroomKey["ClientReference"] = "ClientReference";
    ChatroomKey["PluginName"] = "PluginName";
})(ChatroomKey = exports.ChatroomKey || (exports.ChatroomKey = {}));
var DeliveryMethodId;
(function (DeliveryMethodId) {
    DeliveryMethodId["Chat"] = "Chat";
    DeliveryMethodId["Email"] = "Email";
    DeliveryMethodId["Facebook"] = "Facebook";
    DeliveryMethodId["SMS"] = "SMS";
    DeliveryMethodId["Whatsapp"] = "Whatsapp";
    DeliveryMethodId["Phone"] = "Phone";
})(DeliveryMethodId = exports.DeliveryMethodId || (exports.DeliveryMethodId = {}));
var MessageChannelId;
(function (MessageChannelId) {
    MessageChannelId["FACEBOOK"] = "FACEBOOK";
    MessageChannelId["ENGAGE_BOT"] = "ENGAGE_BOT";
    MessageChannelId["ENGAGE"] = "ENGAGE";
    MessageChannelId["CLUBS"] = "CLUBS";
    MessageChannelId["GROUP_CHAT"] = "GROUP_CHAT";
    MessageChannelId["SOCIAL"] = "SOCIAL";
    MessageChannelId["ANSWERS"] = "ANSWERS";
    MessageChannelId["ANSWERS_STAGING"] = "ANSWERS_STAGING";
    MessageChannelId["DEVIANT_ART"] = "DEVIANT_ART";
    MessageChannelId["CHAT_TEST_PLAYGROUND"] = "CHAT_TEST_PLAYGROUND";
})(MessageChannelId = exports.MessageChannelId || (exports.MessageChannelId = {}));
var OfflineChannelId;
(function (OfflineChannelId) {
    OfflineChannelId["Email"] = "Email";
    OfflineChannelId["Facebook"] = "Facebook";
    OfflineChannelId["SMS"] = "SMS";
    OfflineChannelId["Whatsapp"] = "Whatsapp";
    OfflineChannelId["Phone"] = "Phone";
})(OfflineChannelId = exports.OfflineChannelId || (exports.OfflineChannelId = {}));
var Operator;
(function (Operator) {
    Operator["EqualOrNull"] = "EqualOrNull";
    Operator["Equal"] = "Equal";
})(Operator = exports.Operator || (exports.Operator = {}));
var TenantId;
(function (TenantId) {
    TenantId["Inbox"] = "Inbox";
    TenantId["DeviantArt"] = "DeviantArt";
})(TenantId = exports.TenantId || (exports.TenantId = {}));
